import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import AuthProvider from "./contexts/AuthProvider";
import installApiErrorHandling from "./shared/errors/installApiErrorHandling";
import { captureInstallPrompt } from "./shared/utils/installPrompt";

installApiErrorHandling();
captureInstallPrompt();

ReactDOM.render(
  <App />,
  document.getElementById("root")
);

// Service worker DISABLED 2026-05-30. The Workbox precache strategy was
// aggressively holding old chunks across deploys — buttons rendered with
// stale MUI default styling, fonts didn't refresh, deploys took multiple
// hard-refreshes to land. Explicitly unregister on every load so users
// with the legacy SW installed get cleaned up automatically. Re-enable
// only with a thought-through cache-busting strategy + version skew
// handling.
serviceWorkerRegistration.unregister();
